export default __webpack_public_path__ + "static/WEGC_Logo_medium-808a8de4254a7aade6c18547d394b882.png";